import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { tap, delay } from 'rxjs/operators';
import { HttpService } from './http.service';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
   providedIn: 'root'
})
export class UserService {


   constructor(private httpService: HttpService, private router: Router, private route: ActivatedRoute) { 

   }

   isUserLogin(){
       return localStorage.getItem("user") != undefined && localStorage.getItem("user") != null;
   }
   signup(user: any){

        return this.httpService.post('prod/auth/signup', user);
   }

   login(email: string, password: string) {
    let data = {Email:email, Password:password};
    this.httpService.post('prod/auth/signin', data).subscribe((res: any) => {
        localStorage.setItem("user", res.token);
        this.router.navigate(['/home']);
    },(error:any) => {
        alert(error);
        this.logout();
    });
      
   }

   logout(): void {
        debugger;
        localStorage.removeItem('user');
        this.router.navigate(['./login'], { relativeTo: this.route });
   }

   
}